import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import { WorkedTimeData } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Worked/lib/calculateWorkedTime'

import Item from '../components/Item'
import ItemsBox from '../components/ItemsBox'

interface Props {
  workedTimeData: WorkedTimeData
  hasCorrectiveBreaks: boolean
}

const TimeTracked = ({ workedTimeData, hasCorrectiveBreaks }: Props) => {
  const {
    discardedOrAddedMinutes,
    trackedMinutes,
    unapprovedOvertimeMinutes,
    breaksMinutesRounded,
  } = workedTimeData
  const displayBreakdown = unapprovedOvertimeMinutes > 0 || Math.abs(discardedOrAddedMinutes) > 0
  const discardedTimeTracked = discardedOrAddedMinutes > 0 ? 0 : discardedOrAddedMinutes
  const adjustedTimeTracked = discardedOrAddedMinutes > 0 ? discardedOrAddedMinutes : 0
  const showBreaksCorrectionInfo = hasCorrectiveBreaks && breaksMinutesRounded > 0

  return (
    <ItemsBox
      label={i18n.t('clock_in.sidepanel.worked_hours.time_tracked.title')}
      minutes={trackedMinutes}
      description={i18n.t('clock_in.sidepanel.worked_hours.time_tracked.description')}
      displayBreakdown={displayBreakdown}
    >
      <>
        <Item
          label={i18n.t('clock_in.sidepanel.clocked.unapproved_overtime')}
          minutes={-unapprovedOvertimeMinutes}
        />
        {discardedTimeTracked > 0 && (
          <Item
            label={i18n.t('clock_in.sidepanel.clocked.discarded_time_tracked')}
            minutes={discardedTimeTracked}
          />
        )}
        {adjustedTimeTracked > 0 && (
          <Item
            label={i18n.t('clock_in.sidepanel.clocked.adjusted_time_tracked')}
            minutes={adjustedTimeTracked}
          />
        )}
        {showBreaksCorrectionInfo && (
          <Item
            label={i18n.t('clock_in.breaks.corrective_breaks.title')}
            minutes={-breaksMinutesRounded}
          />
        )}
      </>
    </ItemsBox>
  )
}

export default TimeTracked
